import axios from 'axios'
import qs from 'qs'
import _ from 'lodash'
import AppH5JSSDK from '@i61/app-h5-jssdk'
import mitoLogError from '@/utils/mitoSDK'

function getUrlDomain(originUrl) {
    let domain
    var arr = originUrl.split("/"); //以“/”进行分割
    if (originUrl.startsWith("http") && arr[2]) {
        domain = arr[0] + '//' + arr[2];
    } else {
        domain = ''; //如果url不正确就取空
    }
    return domain
}
function chooseWebsite(originDomain) {
    let webSiteList = JSON.parse(localStorage.getItem('websites')) || []
    for (var i = 0, l = webSiteList.length; i < l; i++) {
        let webSite = webSiteList[i]
        if (webSite.sourceHost == originDomain) {
            return webSite
        }
    }
    return []
}
function getCdnNodeList(originUrl) {
    let originDomain = getUrlDomain(originUrl)
    let webSite = chooseWebsite(originDomain)
    let resourcePathname = _.replace(originUrl, originDomain, '')

    if (!webSite || !webSite.sourceHost) return { nodeList: [], resourcePathname }
    let nodeList = _.map(webSite.nodes, node => {
        return node.host
    })
    nodeList.push(webSite.sourceHost)
    return { nodeList, resourcePathname }
}

const utils = {
    //获取链接的尾部地址
    setFailUrl() {
        let urlFail = ''; //url的尾巴
        let urlSplitArray = window.location.href.split('/type');
        let paramArray = window.location.href.split('?');
        if (urlSplitArray.length > 1) {
            urlFail = '/type' + urlSplitArray[1];
        }
        if (paramArray[1]) {
            urlFail = urlFail + '/?' + paramArray[1];
        }

        return urlFail
    },
    /*
   * 用于获取正确的cdn路径
   * */
    getUrlDomain,
    getVaildUrl(originUrl, resolve) {
        if (!originUrl.startsWith('http')) originUrl = window.location.host + originUrl
        let { nodeList, resourcePathname } = getCdnNodeList(originUrl)
        if (nodeList.length == 0) {  // 匹配不到cdn站点
            resolve(originUrl)
            return
        }
        let resourcePathList = _.map(nodeList, (cdnNode) => {
            return cdnNode + resourcePathname
            // return '/asdfas/dsfas.jpg'
        })
        let index = 0

        function _loadResource() {
            if (index >= resourcePathList.length - 1) {
                resolve(originUrl)
                return
            }
            loadResource(resourcePathList[++index])
        }
        var xhr = new XMLHttpRequest()
        let loadResource = (src) => {
            let lastPath = _.last(_.split(src, '.'))
            let timer = setTimeout(() => {
                xhr.abort()
                _loadResource()
            }, 5000)
            xhr.open("GET", src, true);
            xhr.send(null);
            xhr.onerror = function (data) {
                clearTimeout(timer)
                _loadResource()
            };

            if (lastPath == 'html') {
                xhr.onload = function (data) {
                    clearTimeout(timer)
                    let status = data.srcElement.status
                    if (status == 200) {
                        console.log(src, '------success-----');
                        resolve(src)
                    } else {
                        _loadResource()
                    }
                    return
                }
            } else {
                xhr.onprogress = function (data) {
                    xhr.abort()
                    clearTimeout(timer)
                    if (data.total > 1000) {  //正确的资源都比较大
                        console.log(src, '------success-----');
                        resolve(src)
                        return
                    } else {
                        _loadResource()
                    }
                }
            }


        }
        loadResource(resourcePathList[index])
    },

    //路由跳转
    goHistory(history, url, state = 0) {
        let urlFail = ''; //url的尾巴
        let urlSplitArray = window.location.href.split('/type');
        let paramArray = window.location.href.split('?');
        if (urlSplitArray.length > 1) {
            urlFail = '/type' + urlSplitArray[1][0];
        }
        if (paramArray[1]) {
            urlFail = urlFail + '/?' + paramArray[1];
        }

        if (state) {
            history.push({
                pathname: url + urlFail,
                state: state
            })
        } else {
            history.push(url === '/' ? urlFail : url + urlFail)
        }
    },

    //获取参数
    getparameter(paramName) {
        let paramArray = window.location.href.split('?')[1];
        if (paramArray) {
            paramArray = '&' + paramArray;
            let reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)", "i");
            let r = paramArray.substr(1).match(reg);
            if (r !== null) {
                return unescape(r[2]);
            } else {
                return null;
            }
        } else {
            return null;
        }
    },

    getUrlParams() {
        let url = window.location.href
        let paramArr = url.split('?')[1] ? url.split('?')[1].split('&') : []
        let params = {}
        paramArr.forEach(key => {
            params[key.split('=')[0]] = key.split('=')[1]
        })
        if (params.url) {
            params.url = decodeURIComponent(params.url)
            window.localStorage.setItem('url', params.url)
        }
        return params
    },

    getOptions(name) {
        let paramArray = decodeURIComponent(window.location.href.split('?')[1]).split('&');
        let obj = {}
        for (let i = 0; i < paramArray.length; i++) {
            let arr = paramArray[i].split('=')
            obj[arr[0]] = arr[1]
        }
        return obj[name]
    },

    //调用原生方法
    callNative(method, param) {
        // 逻辑存在问题，不支持多级路由情况
        // if (method === 'toNextPage' && ['10.200.13', '10.200.30'].includes(location.href.slice(7, 16))) {
        //     const hashs = param.url.split('/')
        //     window.location.href = location.origin + '/#/' + hashs[hashs.length - 1];
        //     return Promise.resolve();
        // }
        return new Promise((resolve, reject) => {
            // console.log('callNative:' + method, param)
            if (window.android && window.android[method]) {
                console.log('call android, param', window.android, method, param)
                if (param) {
                    let res = window.android[method](JSON.stringify(param))
                    resolve(res)
                } else {
                    let res = window.android[method]()
                    resolve(res)
                }

            } else if (window.webkit && window.webkit.messageHandlers[method]) {
                console.log('call ios', window.webkit)
                if (param) {
                    let res = window.webkit.messageHandlers[method].postMessage(JSON.stringify(param))
                    resolve(res)
                } else {
                    let res = window.webkit.messageHandlers[method].postMessage('')
                    resolve(res)
                }
            } else {
                reject({ android: window.android, webkit: window.webkit })
            }
        })
    },

    formatTime(timestamp) {
        const month = new Date(Number(timestamp)).getMonth() + 1
        const day = new Date(timestamp).getDate()
        const formatMon = month > 9 ? String(month) : '0' + String(month)
        const formatDay = day > 9 ? String(day) : '0' + String(day)
        return formatMon + formatDay
    },
    getFormatTime(timestampString) {
        const timestamp = Number(timestampString)
        const offset_GMT = new Date(timestamp).getTimezoneOffset()
        const time = new Date(timestamp + offset_GMT * 60 * 1000 + 8 * 60 * 60 * 1000)
        // const year = time.getFullYear()
        // const month = (time.getMonth() + 1) > 9 ? (time.getMonth() + 1) : '0' + (time.getMonth() + 1)
        // const day = time.getDate() > 9 ? time.getDate() : '0' + time.getDate()
        const hour = time.getHours() > 9 ? time.getHours() : '0' + time.getHours()
        const minutes = time.getMinutes() > 9 ? time.getMinutes() : '0' + time.getMinutes()
        const second = time.getSeconds() > 9 ? time.getSeconds() : '0' + time.getSeconds()
        return `${hour}:${minutes}:${second}`

    },
    getRate(value) {
        if (value === 0) {
            return 0
        }
        if (value === 1) {
            return '100'
        }
        return (value * 100).toFixed(2)
        // let str = String(value).slice(2)
        // let len = str.length
        // if (len === 1) {
        //     str = str + '000'
        // } else if (len === 2) {
        //     str = str + '00'
        // } else if (len === 3) {
        //     str = str + '0'
        // }
        // return str.slice(0, 2) + '.' + str.slice(2, 4)
    },
    browser: {
        versions: (function () {
            var u = navigator.userAgent
            return {
                trident: u.indexOf('Trident') > -1, // IE内核
                presto: u.indexOf('Presto') > -1, // opera内核
                webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
                iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1 || u.indexOf('Macintosh') > -1, // 是否iPad
                webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
                weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
                alipay: u.indexOf('AlipayClient') > -1, // 是否支付宝环境
                qq: u.indexOf(' QQ') > -1, // 是否QQ
            }
        }()),
        language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    }
}
function uploadImg(path, fileUrl, file, method, contentType) {
    return new Promise((resolve, reject) => {
        axios[method](path, file, {
            headers: {
                'Content-Type': contentType
            }
        }).then(res => {
            if (res.status === 200) {
                resolve(fileUrl)
            } else {
                reject()
            }
        }, err => {
            reject(err)
        })
    })
}
// 资源位判断
export function getSourceName(source) {
    const sourceList = ["", '首页顶部', '首页腰部', '我页资源位', '弹窗', '开屏', '作业资源位', '学习资源位', '广场资源位', "其他"]
    return sourceList[source];
}
/**
 * 获取url参数
 * 兼容格式1：https://xx.com/?a=111#/path/path2 => {a: 1}
 * 兼容格式1：https://xx.com/#/path/path2?a=111 => {a: 1}
 * @param {*} url
 * @returns
 */
export function getUrlQuery(url) {
    if (!url) return {}
    const { search, hash } = new URL(url)
    let queryStr = ''
    const searchIndex = search.indexOf('?')
    const hashIndex = hash.indexOf('?')

    if (searchIndex >= 0) {
      queryStr = search.slice(searchIndex+1)
    } else if (hashIndex >= 0) {
      queryStr = hash.slice(hashIndex+1)
    }
    return qs.parse(queryStr)
}

/**
 * 获取用户id
 */
export const getUserId = () => {
    let userId = '';
    let hllUserInfoJSON = AppH5JSSDK.getQueryName('hllUserInfo')
    try {
        userId = hllUserInfoJSON ? JSON.parse(hllUserInfoJSON).userId : AppH5JSSDK.getQueryName('userId')
    } catch(e) {
        userId = ''
        mitoLogError({
            tag: 'utils|getUserId|JSONParseError',
            message: `hllUserInfoJSON: ${hllUserInfoJSON}`,
            error: e
        })
    }
    return userId || window.sessionStorage.getItem('userId')
}
export { uploadImg }
export default utils;